import Vue from 'vue'

/**
 * Seconds number formatter to a split time-framed object
 * @name secondsToDurationObject seconds integer to split object
 * @returns {object} Object with the resultant values for each timeframe
 */

const defaultConfigs = {
  showDays: false,
  showHours: true,
  showMinutes: true,
  showSeconds: true,
}

const secondsToDurationObject = (seconds, configs = defaultConfigs) => {

  const { showDays, showHours, showMinutes, showSeconds } = Object.assign({}, defaultConfigs, configs)

  const days = Math.floor(seconds / (3600 * 24))

  seconds -= days * 3600 * 24

  let hrs = Math.floor(seconds / 3600)

  hrs += days && !showDays ? days * 24 : 0
  seconds -= hrs * 3600
  seconds += days && !showDays ? days * 3600 * 24 : 0

  let mnts = Math.floor(seconds / 60)

  mnts += hrs && !showHours ? hrs * 60 : 0
  seconds -= mnts * 60
  seconds += hrs && !showHours ? hrs * 3600 : 0

  seconds += mnts && !showMinutes ? mnts * 60 : 0

  if (!showSeconds) {
    mnts += Math.ceil(seconds / 60)
    if (mnts >= 60) {
      hrs++
      mnts = 0
    }
    seconds = 0
  }

  return {
    days,
    hours: hrs,
    minutes: mnts,
    seconds,
  }
}

Vue.filter('secondsToDurationObject', secondsToDurationObject)

export default secondsToDurationObject
